import { jsx as _jsx } from "react/jsx-runtime";
import { HidableBox } from '@/core/styled';
export const HidableTabPanel = (props) => {
    const { children, ...rest } = props;
    return (_jsx(HidableBox, { role: "tabpanel", ...rest, children: children }));
};
